export default __webpack_public_path__ + "static/media/28.24908f47.mp3";